import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import classNames from 'classnames'

import { Title } from '../Pages'
import { Errors, useForm } from '../Form'

import styles from './Index.module.css'
import pages from '../Pages.module.css'
import form from '../Form.module.css'
import buttons from '../Buttons.module.css'

Index.propTypes = {
  departments: PropTypes.array,
  destinations: PropTypes.array
}

export default function Index ({ departments, destinations }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {
    values,
    setValues,
    saved,
    setSaved,
    handleInputChange,
    errors,
    pending,
    setErrors,
    onSubmit,
    cancelToken
  } = useForm({ name: '', email: '', message: '', department_id: '', destination_id: '' })

  const handleSubmit = async e => {
    await axios.post(
      '/send-mail',
      { feedback: values },
      { cancelToken: cancelToken.current.token }
    ).then(res => {
      setSaved(true)
    }).catch(error => {
      setErrors(error.response.data)
    })
  }

  const openModal = (e) => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }


  useEffect(() => {
    const data = Object.assign({}, values)

    if (data.department_id || data.department_id === '') {
      data.destination_id = ''
    }

    const des = destinations.filter(i => parseInt(i.department_id) === parseInt(values.department_id))

    if (des.length === 1) {
      data.destination_id = `${des[0].id}`
    }

    setValues(data)
  }, [values.department_id])

  return (
    <div className={pages.container}>
      <Title
        h1="Письмо руководству"
      />

      <div className={styles.root}>

        {/* Модалка */}
        {/* {isModalOpen && (
          <div className={styles.modalOverlay} onClick={closeModal}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <div className={styles.modalHeader}>
                <h2 className={styles.modalTitle}>Политика обработки персональных данных</h2>
                <button className={styles.modalClose} onClick={closeModal}>×</button>
              </div>
              <div className={styles.modalBody}>
                <h3>УСЛОВИЯ ИСПОЛЬЗОВАНИЯ СЕРВИСА</h3>
                <p>Настоящие УСЛОВИЯ ИСПОЛЬЗОВАНИЯ СЕРВИСА представляют собой официальный документ (далее - Администратор) (и определяют порядок использования посетителями сайта lunn.ru (далее - Сайт) Сервиса (виджет онлайн-консультант, интегрированный в Сайт) и обработки информации, получаемой от посетителей Сайта при помощи Сервиса. </p>
                <p>Начиная использование Сервиса, посетитель Сайта выражает свое полное и безоговорочное согласие с настоящими УСЛОВИЯМИ ИСПОЛЬЗОВАНИЯ СЕРВИСА, которые определяются Администратором как публичная оферта в соответствии со статьей 437 ГК РФ.</p>
                <p>Посетитель Сайта обязан ознакомиться с настоящими УСЛОВИЯМИ ИСПОЛЬЗОВАНИЯ СЕРВИСА до начала использования Сервиса. Администратором в любое время могут быть изменены Настоящие УСЛОВИЯ ИСПОЛЬЗОВАНИЯ СЕРВИСА, без уведомления пользователя Сайта. </p>
                <h3>Сервис и порядок его использования.</h3>
                <p>Сервис представляет собой комплексный объект авторских и смежных прав, все исключительные права на который принадлежат правообладателю – ООО «Софит» (ОГРН 1133926023274, ИНН 3906297236). </p>
                <p>Использование Сервиса осуществляется пользователями Сайта на безвозмездной основе на условиях простой неисключительной лицензии. Пользователю предоставляется право на работу Сервиса на Сайте Администратора и его последующее использование исключительно в соответствии с его функциональным назначением – для целей коммуникации с Администратором Сайта. </p>
                <h3>Согласие на обработку персональных данных. </h3>
                <p>Информация указанная пользователем при использовании Сервиса, относящаяся к прямо или косвенно определенному или определяемому физическому лицу
                  (далее – персональные данные) будет обработана в соответствии с законодательством Российской Федерации.
                  Пользователь даёт согласие Администратору на обработку всех сообщаемых персональных данных.
                  Администратор обрабатывает персональные данные пользователя исключительно в целях предоставления пользователю функционала Сервиса и Сайта,
                  размещенного на нем контента, маркетинговой, рекламной, иной информации, в целях получения пользователем персонализированной (таргетированной) рекламы,
                  исследования и анализа данных пользователя, а также в целях продвижения пользователю своих товаров и услуг.
                  Администратором будут приняты все необходимые меры для защиты персональных данных пользователя Сайта, а также предоставлен доступ только тем работникам,
                  подрядчикам и агентам Администратора, которым эта информация необходима для обеспечения целей обработки персональных данных Администратором Сайта.
                  Раскрытие предоставленных пользователем персональных данных может быть произведено лишь в соответствии с законодательством Российской Федерации.
                  Администратор вправе в отношении всех сообщенных пользователем своих персональных данных осуществлять сбор систематизацию, накопление, хранение,
                  уточнение (обновление, изменение), использование, распространение (в том числе передача любым третьим лицам, включая передачу персональных данных
                  третьим лицам на хранение или в случае поручения обработки персональных данных третьим лицам), обезличивание, блокирование, уничтожение,
                  трансграничная передача, обработка с применением основных способов такой обработки (хранение, запись на электронных носителях и их хранение,
                  составление перечней, маркировка) и иные действия в соответствии со статьей 3 Федерального закона от 27.06.2006 № 152-ФЗ «О персональных данных»</p>
                <p>В свою очередь пользователь понимает и соглашается с тем, что предоставление Администратору какой-либо информации о себе,
                  не являющейся контактной и не относящейся к целям, указанными Администратором Сайта (не относящейся к деятельности Администратора,
                  к продвигаемым им товарам и/или услугам, к условиям сотрудничества Администратора и пользователя Сайта), а исключительно предоставление информации,
                  относящейся к государственной, банковской и/или коммерческой тайне, информации о расовой и/или национальной принадлежности, политических взглядах,
                  религиозных или философских убеждениях, состоянии здоровья, интимной жизни пользователя Сайта или иного третьего лица запрещено.</p>
                <p>Согласие на обработку персональных данных дается пользователем бессрочно. Пользователь в любое время вправе отозвать данное им согласие путем направления
                  соответствующего заявления в тех поддержку или онлайн чат. Отзыв согласия на обработку персональных данных будет означать автоматическое их удаление
                  Администратором сайта из всех ресурсов, баз данных и накопителей в течение 3-х дней, а также прекращение возможности пользования услугами и сервисами,
                  для которых предоставление персональных данных обязательно.</p>
  
                <h3>Обязанности пользователя Сайта. </h3>
                <p>При посещении Сайта и при использовании Сервиса Пользователь обязан соблюдать правила настоящих УСЛОВИЙ ИСПОЛЬЗОВАНИЯ СЕРВИСА и законодательства Российской Федерации, а также: </p>
                <ul>
                  <li>в случае предоставления пользователем какой-либо информации (каких-либо данных) Администратору, предоставлять исключительно достоверную и актуальную
                    информацию. Пользователь Сайта не вправе вводить Администратора в заблуждение в отношении своей личности, сообщать ложную или недостоверную информацию о себе; </li>
                  <li>не сообщать Администратору любым образом, как с использованием Сервиса, так и в ином порядке, какую-либо информацию, полностью или в части относящуюся к
                    государственной, коммерческой и/или банковской тайне, фактам и информации о своей личной жизни или личной жизни третьих лиц, а также не сообщать
                    иную информацию, предоставление которой запрещено настоящими УСЛОВИЯМИ ИСПОЛЬЗОВАНИЯ СЕРВИСА;  </li>
                  <li>не предоставлять, не сообщать и не передавать Администратору какую-либо информацию (в том числе данные, объекты, контент, условия и тд.) и ссылки
                    на такую информацию если это может нарушать или привести к нарушению законодательства Российской Федерации, нарушить права и интересы третьих лиц.
                    В случае наличия у пользователя сомнений относительно правомерности сообщения какой-либо информации Администратору посредством Сервиса и Сайта,
                    пользователь обязан воздержаться от совершения данного действия; </li>
                  <li>использовать полученную от Администратора информацию (в том числе информацию, переданную Администратором через Сайт и/или Сервис) исключительно
                    для личных целей, не передавать такую информацию третьим лицам без прямого на то согласия Администратора. </li>
                </ul>
  
                <h3>Ограничение ответственности Администратора.</h3>
                <p>На сайте и Сервисе, как и в любом программном обеспечении не исключены ошибки. Сайт, Сервис, весь функционал, включая скрипты, приложения, контент и иную информацию, размещенную на сайте, поставляются на условиях «КАК ЕСТЬ», со всеми недостатками,
                  выявлеными сразу или не сразу. </p>
                <p>Администратор не гарантирует и не обещает каких-либо результатов от использования Сайта или Сервиса. Пользователь Сайта принимая настоящие
                  УСЛОВИЯ ИСПОЛЬЗОВАНИЯ СЕРВИСА соглашается с тем, что Администратор не несет никакой ответственности за функционирование и работоспособность Сервиса.
                  Администратор не несет ответственности за временные сбои и перерывы в работе Сервиса или Сайта и вызванные такими сбоями потери информации.
                  Администратор также не несет никакой ответственности за ущерб, причиненный пользователям Сайта, явившийся результатом использования Сайт или Сервиса.
                  Администратор вправе использовать и распоряжаться информацией пользователя для составления статистической отчетности, использовать ее в рекламных
                  и маркетинговых целях, а также вправе направлять пользователю информацию о своей деятельности и любым способом ее рекламировать. Правообладатель Сервиса
                  (ООО «Софит») не несет никакой ответственности за функционирование Сервиса, за какие-либо последствия его использования пользователями Сайта и/или
                  последствия сообщения или получения какой-либо информации с использованием (с помощью) Сервиса. </p>
  
  
  
              </div>
              <div className={styles.modalFooter}>
                <button className={classNames(buttons.main, buttons.small)} onClick={closeModal}>
                  Закрыть
                </button>
              </div>
            </div>
          </div>
        )} */}
        <div className={styles.form}>
          {saved &&
            <div className={styles.saved}>
              Обращение отправлено и будет обработано в ближайшее время. Мы свяжемся с вами по указанной электронной почте.
            </div>
          }

          {!saved &&
            <form className={classNames(form.root, styles.els)} onSubmit={onSubmit(handleSubmit)}>
              {/* <div className={classNames(form.el, styles.department)}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 4">
                  <path fill="#C4C4C4" d="M0 0h10L5 4 0 0z"/>
                </svg>

                <div className={form.input}>
                  <select name="department_id" onChange={handleInputChange}>
                    <option value="">Направить письмо в...</option>
                    {departments.map(department =>
                      <option value={department.id} key={department.id}>
                        {department.title}
                      </option>
                    )}
                  </select>
                </div>
              </div> */}

              {/* <div className={classNames(form.el, styles.destination, { [styles.disabled]: values.department_id === '' })}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 4">
                  <path fill="#C4C4C4" d="M0 0h10L5 4 0 0z"/>
                </svg>

                <div className={form.input}>
                  <select disabled={values.department_id === ''} name="destination_id" onChange={handleInputChange}>
                    {destinations.filter(i => parseInt(i.department_id) === parseInt(values.department_id)).length !== 1 &&
                      <option value="">Выберите адресата...</option>
                    }

                    {destinations.filter(i => parseInt(i.department_id) === parseInt(values.department_id)).map(destination =>
                      <option value={destination.id} key={destination.id}>
                        {destination.title}
                      </option>
                    )}
                  </select>
                </div>

                <Errors errors={errors.destination} />
              </div> */}

              <div className={classNames(form.el, styles.name)}>
                <div className={classNames(form.input, styles.name)}>
                  <input
                    type="text"
                    value={values.name}
                    name="name"
                    onChange={handleInputChange}
                    required
                  />
                  <div className={form.label}>
                    Имя *
                  </div>
                </div>

                <Errors errors={errors.name} />
              </div>

              <div className={form.el}>
                <div className={classNames(form.input, styles.email)}>
                  <input
                    type="text"
                    value={values.email}
                    name="email"
                    onChange={handleInputChange}
                    required
                  />

                  <div className={form.label}>
                    Почта *
                  </div>
                </div>

                <Errors errors={errors.email} />
              </div>

              <div className={classNames(form.el, styles.message)}>
                <div className={form.input}>
                  <textarea
                    value={values.message}
                    name="message"
                    onChange={handleInputChange}
                    placeholder="Сообщение *"
                  />
                </div>
                <div>
                {/* <p className={classNames(styles.troubleshoot)}>Ведутся технические работы. Форма отправления временно не работает. </p> */}
              </div>

                <Errors errors={errors.message} />
              </div>

              

              <div className={classNames(form.submit, styles.submit)}>
                <input type="submit" value={pending ? 'Отправляем...' : 'Отправить'} className={classNames(buttons.main, buttons.big, { [buttons.pending]: pending })} disabled={
                  // pending || 
                  (values.name === '' || values.email === '' || values.message === ''
                  // values.destination_id === ''
                  )} />
              </div>            
             
              <div className={form.input}>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={values.agreement}
                    name="agreement"
                    onChange={handleInputChange}
                    className={styles.checkbox}
                  />
                  <span className={styles.checkboxText}>
                    Я даю согласие на обработку персональных данных. 
                    <a href='https://lunn.ru/media/sveden/doc/2025/polozhenie_o_poryadke_hraneniya_i_zashchity_personalnyh_dannyh_polzovateley_2025.pdf' className={styles.link}>
                        Ознакомиться
                    </a>.
                  </span>
                </label>
              </div>

            </form>
          }
        </div>
      </div>
    </div>
  )
}
